import { AxiosError } from 'axios';
export function isApiError(error) {
    return error instanceof AxiosError;
}
